import { createSlice } from '@reduxjs/toolkit'

interface StateSlice {
	menuOpen: boolean
	navbarOpen: boolean
	bottomSheetSelect?: string
}

const initialState: StateSlice = {
	navbarOpen: false,
	menuOpen: false,
	bottomSheetSelect: 'home'
}

const stateSlice = createSlice({
	name: 'state',
	initialState,
	reducers: {
		handleNavbarOpen: (state) => {
			state.navbarOpen = !state.navbarOpen
		},
		handleMenuOpen: (state) => {
			state.menuOpen = !state.menuOpen
		},
		handleBottomSheetSelect: (state, action) => {
			state.bottomSheetSelect = action.payload
		},
	},
})

export const {
	handleMenuOpen,
	handleNavbarOpen,
	handleBottomSheetSelect
} = stateSlice.actions

export default stateSlice.reducer
